import Infrastructure from "./Infrastructure";
export default Infrastructure;